var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-nav-sub bg-white sticky top-16 z-5",class:{
    'shadow-sm': !_vm.divider || _vm.scrolled,
  }},[_c('CContainer',{staticClass:"px-6 md:px-8 overflow-x-auto",attrs:{"no-spacing":""}},[(_vm.$slots.default)?_c('div',{staticClass:"border-b flex items-center flex-nowrap",class:{
        'border-transparent': !_vm.divider,
      }},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }